var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeaturesDistrib(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 90,
    viewBox: "0 0 101 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2v86M15.195 2v86M2.426 7.428h12.34M2.425 19.951h12.34M2.425 32.476h12.34M2.425 45h12.34M2.425 57.524h12.34M2.425 70.046h12.34M2.425 82.571h12.34M85.805 2v86M99 2v86M86.235 7.428h12.338M86.236 19.951h12.338M86.236 32.476h12.338M86.236 45h12.338M86.236 57.524h12.338M86.236 70.046h12.338M86.236 82.571h12.338M17.27 74.838h68.535M17.27 15.16h68.535",
    stroke: "#8F55FF",
    strokeWidth: 3,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.491 48.803a1.5 1.5 0 0 1 .85-1.944l6.366-2.495 3.042 7.764-6.367 2.495a1.5 1.5 0 0 1-1.943-.85l-1.948-4.97Z",
    stroke: "#8F55FF",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.674 26.52 35.535 43.598a2 2 0 0 0-.376 2.029l1.902 5.071a2 2 0 0 0 1.758 1.295l22.661 1.306a2 2 0 0 0 1.971-2.742l-9.424-23.456a2 2 0 0 0-3.353-.58ZM34.156 54.386l7.1 10.308a2 2 0 0 0 2.377.727l3.723-1.459a2 2 0 0 0 .9-3.023l-6.1-8.556",
    stroke: "#8F55FF",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m62.323 29.5 4.677-7M77 46.131l-9.197-2.105M72.939 33.764l-7.918 3.102",
    stroke: "#8F55FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesDistrib);
export default __webpack_public_path__ + "static/media/features-distrib.61c32ba84f373ea9464b6d1b874c6a62.svg";
export { ForwardRef as ReactComponent };